import React from 'react'
import cn from 'classnames'
import styles from '../upvalue.module.scss'
import { SignalType } from 'types/signals'
import { SmilePlus } from 'lucide-react'
import WithTooltip from 'components/shared/WithTooltip'

interface SignalOptionsButtonProps {
    signalType: SignalType
    signalOptionsRef: React.RefObject<HTMLDivElement>
    onToggleModal: () => void
    seed?: boolean
}

export function SignalOptionsButton({
    signalType,
    signalOptionsRef,
    onToggleModal,
    seed = false,
}: SignalOptionsButtonProps) {
    const signalTypeClass = seed
        ? styles.signalOptionsSeed
        : signalType === 'boost'
        ? styles.signalOptionsBoost
        : styles.signalOptionsUpvalue

    return (
        <WithTooltip asChild tip="Choose reaction and amount.">
            <div
                ref={signalOptionsRef}
                className={cn(styles.signalOptionsButton, signalTypeClass)}
                onClick={ev => {
                    ev.stopPropagation()
                    ev.preventDefault()
                    onToggleModal()
                }}
                data-testid="signal-options-button"
            >
                <SmilePlus size={18} strokeWidth={2} />
            </div>
        </WithTooltip>
    )
}
